// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chat__container[data-v-f0dfa2ee]{display:flex;flex-direction:column;grid-column-start:1;grid-row-start:1;height:100%;overflow:hidden}.chat__loading-wrapper[data-v-f0dfa2ee]{min-height:400px}.chat__profile-card-wrapper[data-v-f0dfa2ee]{flex:0 0 auto;padding:10px;position:relative}.chat__input-wrapper[data-v-f0dfa2ee]{border-radius:inherit;flex:0 0 auto;padding:10px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
